function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

import $ from "jquery";
import Foundation from "./_foundation";
import "motion-ui/dist/motion-ui"; // import AOS from 'aos'

import throttle from "lodash/throttle"; // import '../../node_modules/jquery-parallax.js/parallax.min.js'

import { inlineSVG } from "./_inline-svg";
import { lazyImages, lazyBackgrounds, lazyVideos, lazyOembeds, lazyInterchange } from "./_lazy-load"; // import { smoothScrollOnPageLoad } from "./_smoothScrollOnPageLoad";

import "./_skip-link-focus-fix";
import "./_acf-map";
import "./_fixed-header";
import "./_header-height"; // import './_hero-slider'

import "./_notification";
import "./_scroll-to-top";
import "./_slick";
import "./_social-share-sticky"; // import './_off-canvas'
// import './_faqs_accordion'
// import './_fragmentURLs'

/* Additional Scripts */
// import { randomString } from './_random-string'
// import { equalHeights } from './_equal-height'

import "./_ie"; // Foundation

$(document).foundation(); // Inline SVG

inlineSVG(); // Smooth Scroll on page load
// smoothScrollOnPageLoad();
// Lazy-load on DOMContentLoaded

window.addEventListener("DOMContentLoaded", function () {
  lazyImages();
  lazyBackgrounds();
  lazyVideos();
  lazyOembeds();
  lazyInterchange();
}, false); // Lazy-load on scroll event

window.addEventListener("scroll", throttle(lazyImages, 75), {
  passive: true
});
window.addEventListener("scroll", throttle(lazyBackgrounds, 75), {
  passive: true
});
window.addEventListener("scroll", throttle(lazyOembeds, 75), {
  passive: true
});
window.addEventListener("scroll", throttle(lazyInterchange, 75), {
  passive: true
}); // AOS
// AOS.init();
// Mega Menu Positioning

$(".megamenu .sub-menu").each(function (i) {
  $(this).css({
    left: -$(this).width() / 2
  });
});

if ($(".js-form").length > 0) {
  $(".js-form").css({
    top: $(".site-header").outerHeight() - $(".js-form").offset().top + 4
  });
  $(".js-form .location select").val(Cookies.get("region_name")).css({
    color: "#212121"
  });
  $(".js-extra-form .location select").val(Cookies.get("region_name")).css({
    color: "#212121"
  }); // $(".single-traffic_tickets .js-form .ticket-type select")
  //     .val($("body").data("name"))
  //     .css({ color: "#212121" });
  // $(".single-criminal_charges .js-form .ticket-type select")
  //     .val($("body").data("name"))
  //     .css({ color: "#212121" });

  $(".js-form .ticket-type select").change(function () {
    $("body").attr("data-type", $(".js-form .ticket-type select").val());
  });
  $(".js-extra-form .ticket-type select").change(function () {
    $("body").attr("data-type", $(".js-extra-form .ticket-type select").val());
  });
}

$("button[data-next]").click(function (e) {
  e.preventDefault();
  var step = parseInt($(this).data("next"));
  var next = step + 1;

  if ($(this).hasClass("max")) {
    var next = 0;
  }

  $(".js-" + step).hide();
  $(".js-" + next).fadeIn("slow");
});
$(".site-region__current a").click(function (e) {
  e.preventDefault();

  if (Cookies.get("region_slug") != $(this).data("region")) {
    Cookies.set("region_slug", $(this).data("region"), {
      path: "/"
    });
    Cookies.set("region_name", $(this).text(), {
      path: "/"
    });
    var old = location.href.split("/");
    var url = location.href;

    if ($(this).data("region") == "on" && $("body").hasClass("slug-me")) {
      url = location.href.replace(old[3] + "/", "");
    } else {
      if ($(this).data("region") != old[3] && $("body").hasClass("slug-me")) {
        url = location.href.replace(old[2], old[2] + "/" + $(this).data("region"));
      }
    }

    location.replace(url);
  }
});

if ($(".js-stop-form").length > 0) {
  $(window).on("scroll", function (e) {
    var stopForm = $(".js-stop-form").offset().top - $(".site-header").outerHeight() - $(".js-form").outerHeight() - 35;

    if ($(window).scrollTop() > $(".site-header").outerHeight()) {
      $(".js-form").css({
        top: $(window).scrollTop() - $(".site-header").outerHeight() + 15
      });

      if ($(window).scrollTop() - $(".site-header").outerHeight() + 30 >= stopForm) {
        $(".js-form").css({
          top: stopForm
        });
      }
    } else {
      $(".js-form").css({
        top: 4
      });
    }
  });
}

if ($(".js-home-stop").length > 0) {
  var org = $(".js-form").css("top");
  $(window).on("scroll", function (e) {
    var stopForm = $(".js-home-stop").offset().top - $(".site-header").outerHeight() - $(".js-form").outerHeight() + parseInt(org);

    if ($(window).scrollTop() > $(".site-header").outerHeight()) {
      $(".js-form").css({
        top: $(window).scrollTop() + parseInt(org) - $(".site-header").outerHeight()
      });

      if ($(window).scrollTop() - $(".site-header").outerHeight() + parseInt(org) >= stopForm) {
        $(".js-form").css({
          top: stopForm
        });
      }
    } else {
      $(".js-form").css({
        top: org
      });
    }
  });
}

$(".js-site-search").on("click", function (e) {
  e.preventDefault();
  $(".search-form").css({
    width: $(this).offset().left - $("#menu-primary-menu-1").offset().left + 20,
    right: $(".site-actions").outerWidth() - $(this).outerWidth()
  }).toggleClass("active");
});
$(".js-site-search-close").on("click", function (e) {
  e.preventDefault();
  $(".search-form").css({
    width: 0
  }).toggleClass("active");
});

if ($(".is-mobile .generic-content ul").length > 0) {
  $(".generic-content ul").each(function (i, v) {
    $(this).prev("h4").addClass("small-heading");
  });
  $(document).on("click", "h4.small-heading", function (e) {
    $(this).next("ul").slideToggle();
  });
}

if ($(window).width() > 768 && $(window).height() < 768) {
  $(".js-form .gform_body").css({
    maxHeight: 350,
    overflowY: "scroll"
  });
}

$(window).resize(function () {
  if ($(window).width() > 768 && $(window).height() < 768) {
    $(".js-form .gform_body").css({
      maxHeight: 350,
      overflowY: "scroll"
    });
  } else {
    $(".js-form .gform_body").css({
      maxHeight: "100%",
      overflowY: "auto"
    });
  }
});
$(".js-location-select").change(function (e) {
  var $this = $(this);
  $this.attr("disabled", "disabled");

  if (document.location.href.indexOf($this.find(":selected").data("slug")) <= -1) {
    window.history.replaceState(null, null, $this.find(":selected").data("slug"));
  }

  $.ajax({
    type: "GET",
    url: api.review + $this.val(),
    success: function success(response) {
      if (response.data.facebook) $(".js-facebook").attr("href", response.data.facebook).addClass("block");
      if (response.data.google) $(".js-google").attr("href", response.data.google).addClass("block");
      if (response.data.yelp) $(".js-yelp").attr("href", response.data.yelp).addClass("block");

      if (response.data.location) {
        var loc = response.data.location;
        $(".js-title").text(loc.replace("&#8211;", "-"));
      }

      $(".review-locations__select").fadeOut("fast");
      $(".review-locations__results").fadeIn("slow");
    }
  });
});
var attr = $(".review-locations").attr("data-location");

if (_typeof(attr) !== (typeof undefined === "undefined" ? "undefined" : _typeof(undefined)) && attr !== false) {
  $(".js-location-select").val(attr).trigger("change");
}

$("select").click(function () {
  $(this).css({
    color: "#212121"
  });
});

if ($(".after-block").length > 0) {
  $(".after-block").css({
    top: parseFloat($(".js-form").outerHeight() + 20)
  });
}

if ($("#gf_3").length > 0) {
  $("body .gform_title").html("GET MY FREE QUOTE");
}

$('a[data-open="text-steps"]').click(function () {
  $.getJSON("https://api.ipgeolocation.io/ipgeo?apiKey=be6f4bff8a404474bdbce460b37db6d0&ip=" + api.ip, function (data) {
    if (data.latitude) {
      if (data.latitude < 45.369514 && data.longitude < -80.05) {
        var href = $(".js-new").attr("href").replace("416", "519");
        var hrefs = $(".js-new-phone").attr("href").replace("416", "519");
        var html = $(".js-new").html().replace("416", "519");
        $(".js-new").attr("href", href);
        $(".js-new").html(html);
        $(".js-new-phone").attr("href", hrefs);
      } else if (data.latitude < 46.331758 && data.longitude > -77.97821) {
        var href = $(".js-new").attr("href").replace("416", "613");
        var hrefs = $(".js-new-phone").attr("href").replace("416", "613");
        var html = $(".js-new").html().replace("416", "613");
        $(".js-new").attr("href", href);
        $(".js-new").html(html);
        $(".js-new-phone").attr("href", hrefs);
      } else if (data.latitude > 44.228596) {
        var href = $(".js-new").attr("href").replace("416", "705");
        var hrefs = $(".js-new-phone").attr("href").replace("416", "705");
        var html = $(".js-new").html().replace("416", "705");
        $(".js-new").attr("href", href);
        $(".js-new").html(html);
        $(".js-new-phone").attr("href", hrefs);
      }
    }
  });
});